import { render, staticRenderFns } from "./analysisCard.vue?vue&type=template&id=5c2abdf7&scoped=true"
import script from "./analysisCard.vue?vue&type=script&lang=js"
export * from "./analysisCard.vue?vue&type=script&lang=js"
import style0 from "./analysisCard.vue?vue&type=style&index=0&id=5c2abdf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2abdf7",
  null
  
)

export default component.exports